import type { Theme } from '@mui/material/styles'

const verticalPadding = 0.8
export const navigationWidthStyles = {
  maxWidth: 'var(--content-M-max-width)',
  mx: {
    xs: 1,
    md: 'auto',
  },
}

const styles = {
  fixed: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    maxWidth: '100%',
    backgroundColor: 'transparent',
  },
  root: {
    position: 'relative',
    zIndex: 2,
    color: 'primary.main',
    backgroundColor: 'neutral.black',
    height: 'var(--payper-bar-height)',
  },
  navigation: (theme: Theme) => ({
    color: 'inherit',
    backgroundColor: 'inherit',
    ...navigationWidthStyles,

    py: (theme: Theme) => theme.spacing(verticalPadding),

    '& button': {
      height: (theme: Theme) => theme.spacing(3),
      p: 0,
      minWidth: { xs: 'auto', md: 'inherit' },
      '--button-color': theme.palette.primary.main,
      '&:disabled': {
        '--button-color': theme.palette.neutral.main,
        color: 'var(--button-color)',
      },
    },
    '& svg, span': {
      color: 'var(--button-color)',
    },
    '& .MuiBottomNavigationAction-label': {
      mt: (theme: Theme) => theme.spacing(0.3),
      fontSize: { xs: 10, md: 12 },
    },
    '& .Mui-selected': {
      '& .MuiBottomNavigationAction-label': {
        fontWeight: { xs: 600, md: 700 },
        fontSize: { xs: 11, md: 14 },
      },
    },
  }),
}

export default styles
